import React from 'react';
import Divider from 'components/Divider';
import Link from 'components/Link';
import LinkConstants from 'constants/LinkConstants';
import Row from 'components/Row';
import Text from 'components/Text';
import { DeviceType } from 'auth/components/ConfirmDevice';

export type Props = {
  deviceType: DeviceType;
  onResendCode: () => void;
};

export default function ConfirmDeviceFooter(props: Props) {
  const { deviceType, onResendCode } = props;
  return (
    <>
      <Divider size="medium" />
      <Row size="xxsmall">
        <Text color="graphite">
          Didn’t receive our email?{' '}
          <Link
            data-test="resend-sms-conf-link"
            onClick={onResendCode}
            eventKey={`log_in.confirm_${deviceType}_page.resend.click`}
          >
            Resend
          </Link>{' '}
          or{' '}
          <Link
            href={LinkConstants.CONTACT_HELP}
            target="_blank"
            eventKey={`log_in.confirm_${deviceType}_page.contact_support.click`}
          >
            contact Support
          </Link>
        </Text>
      </Row>
    </>
  );
}
